import React from 'react'
import CTAButton from '../CTA/cta'
import Markdown from '../Markdown/markdown'
import './story.scss'

class Story extends React.Component {

  state = {
    showImage: null
  }

  componentDidMount() {
    if (this.props.content) {

      const content = this.props.content
      const contentBlock = content && content.content ? content.content : null

      this.setState({
        ...(content && content.storyVariation ? {storyVariation: content.storyVariation} : {storyVariation: 'standard'}),
        ...(content && content.textPosition ? {textPosition: content.textPosition} : {textPosition: 'Left'}),
        ...(content && content.featureImageType ? {featureImageType: content.featureImageType} : {featureImageType: 'normal'}),
        ...(contentBlock && contentBlock.backgroundColor ? {style: {backgroundColor: contentBlock.backgroundColor}} : {style: {}}),
        ...(contentBlock && contentBlock.image && contentBlock.image[0].file && contentBlock.image[0].file.url ? {imageUrl: contentBlock.image[0].file.url} : {}),
        ...(content && content.storyVariation === 'image-carousel' && contentBlock && contentBlock.image ? {carouselImages: contentBlock.image} : {}),
        ...(contentBlock && contentBlock.heading ? {heading: contentBlock.heading} : {}),
        ...(contentBlock && contentBlock.body && contentBlock.body.body ? {body: contentBlock.body.body} : {}),
        ...(contentBlock && contentBlock.ctaButtons && contentBlock.ctaButtons[0] && contentBlock.ctaButtons[0].title && contentBlock.ctaButtons[0].url ? {btnPrimary: {title: contentBlock.ctaButtons[0].title, url: contentBlock.ctaButtons[0].url}} : {}),
        ...(contentBlock && contentBlock.ctaButtons && contentBlock.ctaButtons[1] && contentBlock.ctaButtons[1].title && contentBlock.ctaButtons[1].url ? {btnSecondary: {title: contentBlock.ctaButtons[1].title, url: contentBlock.ctaButtons[1].url}} : {}),
        ...(content && content.storyVariation === 'image-carousel' && contentBlock && contentBlock.image ? {showImage: 0} : {showImage: null})
      })
    }
  }
  
  render () {    
    if (this.state.storyVariation === 'full-width' || this.state.storyVariation === 'standard') {
      return(
        <div className={this.state.storyVariation === 'full-width' ? "story-fullwidth" : "story-standard"} style={this.state.storyVariation === 'full-width' ? this.state.style : {}}>
          <div className={"story-content-wrapper " +
            (this.state.featureImageType === 'background' ? "story-content-full " : "story-content-half ") +
            (this.state.featureImageType === 'background' && this.state.textPosition === 'Right' ? "story-justify-right"
            : this.state.featureImageType === 'background' ? "story-justify-left"
            : this.state.featureImageType === 'normal' && this.state.textPosition === 'Right' ? "story-order-right"
            : "story-order-left")}
            style={this.state.style}>
            <div className="story-content">
              {this.state.heading ? <h2 className="story-heading">{this.state.heading}</h2> : null}
              {this.state.body ? <div className="story-body"><Markdown content={this.state.body}/></div> : null}
              {this.state.btnPrimary ? <div className="story-cta"><CTAButton title={this.state.btnPrimary.title} url={this.state.btnPrimary.url} style={ this.state.btnPrimary.style }/></div> : null}
              {this.state.btnSecondary ? <div className="story-cta"><CTAButton title={this.state.btnSecondary.title} url={this.state.btnSecondary.url} style={ this.state.btnPrimary.style } /></div> : null}
            </div>
          </div>
          <div className={"story-image-wrapper " +
            (this.state.featureImageType === 'background' ? "story-image-full " : "story-image-half ") +
            (this.state.featureImageType === 'normal' && this.state.textPosition === 'Right' ? "story-order-left" : "story-order-right")}
            style={this.state.style}>
            <img src={this.state.imageUrl} className="story-image"/>
          </div>
        </div>
      )
    } else if (this.state.storyVariation === '50-50') {
      return (
        <div className="story-50-50">
          <div className={"story-content-wrapper " + (this.state.textPosition === 'Right' ? "story-order-right" : "story-order-left")}
            style={this.state.style}>
            <div className="story-content">
              {this.state.heading ? <h2 className="story-heading">{this.state.heading}</h2> : null}
              {this.state.body ? <div className="story-body"><Markdown content={this.state.body}/></div> : null}
              {this.state.btnPrimary ? <div className="story-cta"><CTAButton title={this.state.btnPrimary.title} url={this.state.btnPrimary.url} style={ this.state.btnPrimary.style }/></div> : null}
              {this.state.btnSecondary ? <div className="story-cta"><CTAButton title={this.state.btnSecondary.title} url={this.state.btnSecondary.url} style={ this.state.btnPrimary.style }/></div> : null}
            </div>
          </div>
          <div className={"story-image-wrapper " + (this.state.textPosition === 'Right' ? "story-order-left" : "story-order-right")} style={this.state.style}>
            <img src={this.state.imageUrl} className="story-image"/>
          </div>
        </div>
      )
    } else if (this.state.storyVariation === 'image-carousel') {
      return (
        <div className="story-image-carousel">
          <div className={"story-content-wrapper " + (this.state.textPosition === 'Right' ? "story-order-right" : "story-order-left")}
            style={this.state.style}>
            <div className="story-content">
              {this.state.heading ? <h2 className="story-heading">{this.state.heading}</h2> : null}
              {this.state.body ? <div className="story-body"><Markdown content={this.state.body}/></div> : null}
              {this.state.btnPrimary ? <div className="story-cta"><CTAButton title={this.state.btnPrimary.title} url={this.state.btnPrimary.url} style={ this.state.btnPrimary.style }/></div> : null}
              {this.state.btnSecondary ? <div className="story-cta"><CTAButton title={this.state.btnSecondary.title} url={this.state.btnSecondary.url} style={ this.state.btnPrimary.style }/></div> : null}
            </div>
          </div>
          {this.state.carouselImages ? <div className={"story-image-wrapper " + (this.state.textPosition === 'Right' ? "story-order-left" : "story-order-right")} style={{...this.state.style, ...(this.state.textPosition === 'Left' ? {alignItems: 'flex-start'} : {})}}>
            <img src={this.state.carouselImages[this.state.showImage].file.url} className="story-image"/>
            {this.state.carouselImages.length > 1 ? <div className={`carousel-pagination`}>
              {this.state.carouselImages.map((image, i) => {
                return <button onClick={() => this.setState({showImage: i})} key={i} className={"btn-pagination " + (this.state.showImage === i ? "btn-pagination-active" : "")}>{(i+1)}</button>})}
            </div> : null}
          </div> : null}
        </div>
      )
    } else {
      return (
        <div></div>
      )
    }
  }
}

export default Story


// WEBPACK FOOTER //
// ./src/components/Story/story.js